// extracted by mini-css-extract-plugin
export default {"wrap":"header_wrap__NPWyI","wrapB":"header_wrapB__Y8Zfg","content":"header_content__HKG-r","mobMenuIcon":"header_mobMenuIcon__B2hMz"};